import { useAuth } from  './contexts/auth'; 


export const valutaOptions =  [{id:1,desc: 'EUR'},{id:2,desc: 'DIH'},{id:3,desc: 'USD'}];
export const formeGiuridicheOptions =  [{id:1,desc: 'Ditta individuale'},{id:2,desc: 'Società in nome collettivo (S.n.c.)'},{id:3,desc: 'Società in accomandita semplice (S.a.s.)'}
,{id:4,desc: 'Società a responsabilità limitata (S.r.l.)'},{id:5,desc: 'Società per azioni (S.p.A.)'},{id:6,desc: 'Società in accomandita per azioni (S.a.p.A.)'},{id:7,desc: 'Cooperativa'}];

export const modalitàPagamentoOptions =  [{id:1,desc: 'MP02 - assegno'},{id:2,desc: 'MP05 - bonifico'},{id:3,desc: 'MP08 - carta di pagamento'},{id:4,desc: 'MP09 - RID'},{id:5,desc: 'MP12 - RIBA'},{id:6,desc: 'MP13 - MAV'}];

export const tipoDocOptions =  [{id:'PRJ',desc: 'Commessa'},{id:'OFF',desc: 'Offerta'},{id:'COR',desc: 'Ordine Cliente'},{id:'SOR',desc: 'Ordine Fornitore'},{id:'CIN',desc: 'Fattura Cliente'}, {id:'SIN',desc: 'Fattura Fornitore'}, {id:'CRN',desc: 'Nota di Credito'}, {id:'CSI',desc: 'Autofattura'}];

export const commessaStatoOptions =  [{id:1,desc: 'Conferma ordine'},{id:2,desc: 'Engeneering'},{id:3,desc: 'Purchising'},{id:4,desc: 'Manifacturing'},{id:5,desc: 'Shipment'},{id:6,desc: 'Erection'},{id:7,desc: 'Commissioning'},{id:8,desc: 'Closeout'},{id:9,desc: 'Chiusa'}];

export const tipoPagamentoOptions =  [{id:'TP01',desc: 'Pagamento a rate'},{id:'TP02',desc: 'Pagamento Completo'},{id:'TP03',desc: 'Anticipo'}];

export const percImponibileRitOptions =  [{id:50,desc: '50%'},{id:100,desc: '100%'}];

export const percCassaPrevidenzialeOptions =  [{id:0,desc: '<nessuna>'},{id:50,desc: '5.0%'},{id:85,desc: '8.5%'}];

export const prioritaOptions = [{id:1, desc:'Bassa'}, {id:2,desc:'Media'}, {id:3,desc:'Alta'}];

export const acquisizioneOptions = [{id:30, desc:'30% - Poco probabile'}, {id:60,desc:'60% - Probabile'}, {id:90,desc:'90% - Molto probabile'}];

export const tipoFEOptions = [{id:'0', desc:'Fattura Cliente'}, {id:'1',desc:'Fattura Fornitore'}];

export const tipoAttivitaOptions =  [{id:1, desc: 'Telefonata'},{id:2,desc: 'Email'},{id:3,desc: 'Incontro'},{id:0,desc: 'Altro'}];
export const statoNotificaAttivitaOptions =  [{id:0, desc: 'Non Inviare'},{id:1, desc: 'Invia'},{id:2,desc: 'Inviata'}];

export const categoriaDocumentoOptions =  [{id:0, desc: '<Seleziona>'},{id:1, desc: 'Sicurezza'},{id:2,desc: 'Qualità'},{id:3,desc: 'Ambiente'},{id:4,desc: 'Personale'},{id:5,desc: 'Check List'}];

export const tipoEventoFEOptions =  [{id:'NS',desc: 'Notifica di scarto'},{id:'RC',desc: 'Ricevuta Consegna'},{id:'MC',desc: 'Mancata Consegna'},{id:'NE',desc: 'Notifica esito'},{id:'DT',desc: 'Notifica decorrenza termini'},{id:'AT',desc: 'Impossibilità di recapito'},{id:'FF',desc: 'Notifica fattura fornitore'}];


export const statusOffertaProgress = (e) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "statoId") 
        {  if (e.data.statoId === 1)
            e.cellElement.style.cssText = "color: white; background-color: #558ea7";
           else if  
           (e.data.statoId === 2)
            e.cellElement.style.cssText = "color: white; background-color: orange";
            else if  
           (e.data.statoId === 3)
            e.cellElement.style.cssText = "color: white; background-color: green";
            else if  
            (e.data.statoId === 4)
             e.cellElement.style.cssText = "color: white; background-color: red";
             else if 
             (e.data.statoId === 5)
             e.cellElement.style.cssText = "color: white; background-color: grey";
             else if 
             (e.data.statoId === 6)
             e.cellElement.style.cssText = "color: white; background-color: blue";
             else if 
             (e.data.statoId === 7)
             e.cellElement.style.cssText = "color: white; background-color: #30B7E0";
             else if 
             (e.data.statoId === 8)
             e.cellElement.style.cssText = "color: white; background-color: #E0CF1C";
             else if 
             (e.data.statoId === 9)
             e.cellElement.style.cssText = "color: white; background-color: #1BE02B";
             else if 
             (e.data.statoId === 10)
             e.cellElement.style.cssText = "color: white; background-color: #DDBBFF";
             else if 
             (e.data.statoId === 11)
             e.cellElement.style.cssText = "color: white; background-color:rgb(128, 86, 226)";
        }
        if (e.column.dataField === "dataScadenzaPresentazione") 
        { 
          var dataScadenza = e.data.dataScadenzaPresentazione;
          var dataEvasione = e.data.dataInvio;
  
          if ((dataEvasione !== null))
          {
            e.cellElement.style.cssText = "color: lightgreen;font-weight: bold";
          }
          else if (dataScadenza < TodayFormatted())
          {
            e.cellElement.style.cssText = "color: red; font-weight: bold";
          }
          else if ((dataScadenza < SevenDaysFormatted()) &&  (dataScadenza > TodayFormatted()) )
          {
              e.cellElement.style.cssText = "color: orange; font-weight: bold";
          }
        
        }
    }
}

export const statusCommessaProgress = (e) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "statoId") 
        {   if (e.data.statoId === 1)
                e.cellElement.style.cssText = "color: white; background-color: #558ea7";
            else if (e.data.statoId === 9)
                e.cellElement.style.cssText = "color: white; background-color: red";
            else if  (e.data.statoId === 2)
                e.cellElement.style.cssText = "color: white; background-color: #E0CF1C";
            else if  (e.data.statoId === 3)    
                e.cellElement.style.cssText = "color: white; background-color: orange";
            else if  (e.data.statoId === 4)
                e.cellElement.style.cssText = "color: white; background-color: #8056e2";
            else if  (e.data.statoId === 5)
                e.cellElement.style.cssText = "color: white; background-color: #1BE02B";
            else if  (e.data.statoId === 6)
                e.cellElement.style.cssText = "color: white; background-color: green";
            else if (e.data.statoId === 7)
                e.cellElement.style.cssText = "color: white; background-color: #30B7E0";
            else if (e.data.statoId === 8)
                e.cellElement.style.cssText = "color: white; background-color: blue";
        }   
    }
}

export function Logout() {
    localStorage.removeItem('ac-user');
    window.location.reload();
}

export function IsRole_Admin() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("ADMIN");
    
    return isRole;
}

export function IsRole_Manager() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("MANAGER");
    
    return isRole;
}
export function IsRole_OfficeManager() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("OFFICEMANAGER");
    
    return isRole;
}
export function IsRole_OfficeDirector() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("OFFICEDIRECTOR");
    
    return isRole;
}
export function IsRole_Operator() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("OPERATOR");
    
    return isRole;
}

export function IsRole_Designer() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("DESIGNER");
    
    return isRole;
}
//manager indica il responsabile del team
export function IsRole_SalesManager() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("SALESMANAGER");
    
    return isRole;
}
//director indica ruolo dirigenziale
export function IsRole_SalesDirector() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("SALESDIRECTOR");
    
    return isRole;
}
export function IsRole_SecurityManager() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("SECURITYMANAGER");
    
    return isRole;
}
export function IsRole_Technical() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("TECHNICAL");
    
    return isRole;
}
export function IsRole_ProjectManager() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("PROJECTMANAGER");
    
    return isRole;
}
export function IsRole_AssistantPM() {
    const { user } = useAuth(); 
    const isRole = user.roles.includes("ASSISTANTPM");
    
    return isRole;
}


export function SevenDaysFormatted() {

    const sevenDays = new Date();
    sevenDays.setDate(sevenDays.getDate() +7);
    const yyyy2 = sevenDays.getFullYear();
    let mm2 = sevenDays.getMonth() + 1; // month is zero-based
    let dd2 = sevenDays.getDate();

    if (dd2 < 10) dd2 = '0' + dd2;
    if (mm2 < 10) mm2 = '0' + mm2;

    return yyyy2 + '-' + mm2 + '-' + dd2 + 'T00:00:00';
}

export function TodayFormatted(){

    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // month is zero-based
    let dd = today.getDate();
    
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return yyyy + '-' + mm + '-' + dd + 'T00:00:00';
  }


export function getQuarterDates() {
    const now = new Date();
    const currentMonth = now.getMonth();
    const quarter = Math.floor(currentMonth / 3);
    const startMonth = quarter * 3;

    const startDate = new Date(now.getFullYear(), startMonth, 1);
    const endDate = new Date(now.getFullYear(), startMonth + 3, 0);

    return {
        start: formatDateLocal(startDate),
        end: formatDateLocal(endDate),
    };
}

function formatDateLocal(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
